const FILTERS = {
  "vsp-one-sdsblock-terraform": {
    vsp_one_block_terraform_provider: {
      title: "VSP One Block Terraform Provider",
      icon: "server.png",
    },
    terraform: {
      title: "Terraform",
      icon: "server.png",
    },
    golang: {
      title: "Golang",
      icon: "server.png",
    },
    software_version: {
      title: "Software Version",
      icon: "os.png",
    },
  },
};
export default FILTERS;
